import { useEffect, useRef, useState } from 'react'
import { BaseButtons, BaseFeedbackConIcona, BaseContenutoConProgress } from '@lucan/base-ui'
import { useSessione } from 'context/SessioneProvider'
import { Box, Card, CardContent, Chip, Link, LinearProgress , List, ListItem, Typography, Grid, Button } from '@mui/material'
import Titolo from 'components/ui/Titolo'
import LineaSeparatrice from 'components/ui/LineaSeparatrice'
import Sottotitolo from 'components/ui/Sottotitolo'
import Contenitore from 'components/ui/Contenitore'
import Titoletto from 'components/ui/Titoletto'
import Markdown from 'markdown-to-jsx'
import { Link as RouterLink } from 'react-router-dom';
import BaseBreadcrumbs from 'components/BaseBreadcrumbs'
import FrontofficeContenitore from './FrontofficeContenitore'

const testi = {
  breadcrumbs :{
  sequenzaRoutes: [
      {
        label: "Home",
        pathAssoluto: "https://www.comune.cuneo.it/"
      },{
        label: "Servizi",
        pathAssoluto: "https://www.comune.cuneo.it/servizi"
      },{
        label: "Tributi, finanze e contravvenzioni",
        pathAssoluto: "https://www.comune.cuneo.it/servizi-categoria/tributi-finanze-e-contravvenzioni/"
      }, {
        label: "Pagamento contravvenzione",
      }
    ]
  },
  titolo: "Pagamento multa",
  descrizione:"Paga online le multe ricevute dalla polizia municipale o prenota un appuntamento per pagare presso gli uffici",
  sections:[
    { id: "1" ,label:"A chi è rivolto",content:"Il servizio è destinato a tutti i cittadini che devono pagare multe della polizia municipale, prese a seguito di infrazioni del codice della strada nel territorio comunale." },
    { id: "2" ,label:"Come fare",content:"Per pagare online, accedi con le tue credenziali di identità digitale e fornisci le informazioni su chi effettua il pagamento e gli estremi della multa. Puoi pagare con conto o carta tramite il servizio pagoPA e scaricare subito la ricevuta. In alternativa, puoi prenotare un appuntamento e recarti presso gli uffici."
        },
    { id: "3" ,label:"Cosa serve",content:
      `Per il pagamento delle multe, assicurati di avere:
*   La notifica della multa
*   Il Codice Avviso PagoPA, che trovi sull’avviso di pagamento
*   La targa del veicolo
*   I dettagli del conto o della carta con cui vuoi effettuare il pagamento` },
    { id: "4" ,label:"Tempi e scadenze",content:
`*   Per i pagamenti entro 5 giorni dalla notifica o dalla contestazione immediata, si applica uno sconto del 30% sull’importo;
*   Per i pagamenti entro 60 giorni, si paga una sanzione in misura ridotta;
*   Per i pagamenti oltre 60 giorni, si paga la sanzione raddoppiata più gli interessi.

[Regolamento polizia municipale (PDF 80KB)](www.google.it) `},
    { id: "5" ,label:"Costi",content:`Il servizio di pagamento online prevede 0,50€ di costi di commissione.` },
    { id: "6" ,label:"Accedi al servizio",
      content:`
Puoi pagare la multa direttamente online tramite identità digitale.

[![Button "Paga online" color=success variant=contained]][/frontoffice/]

Oppure, puoi pagare presso gli uffici di Polizia municipale.

[![Button "Prenota appuntamento" color=success variant=outlined]][https://example.com]
`,in_evidenza: true} ,
    
   { id: "7" ,label:"Condizioni di servizio",content:
    `Per conoscere i dettagli di scadenze, 
requisiti e altre informazioni importanti, leggi i termini e le condizioni di servizio.
[Termini e condizioni di servizio (PDF 1MB)](www.google.it)` },
    { id: "8" ,label:"Contatti", type: "contatti", contatti: {
                              titolo: "Ufficio polizia Municipale",
                              indirizzo: "via dei transiti 21, 50302",
                              telefono: "05050340",
                              mail: "uffifiotributi@email.it",
                              }
    },
  ]

} 




export default function FrontofficeDescrizione() {
  const { ScatolaMessaggi, messaggioErrore, inAttesaDelServer } = useSessione()

  return (
    <>
      {ScatolaMessaggi}

      {messaggioErrore && <BaseFeedbackConIcona.Errore messaggio={messaggioErrore} />}

      <BaseContenutoConProgress inAttesa={inAttesaDelServer}>
        <LoginUtenteOChiaveVerbale />
      </BaseContenutoConProgress>
    </>
  )
}



function LoginUtenteOChiaveVerbale() {

  return (
    <FrontofficeContenitore>
      <BaseBreadcrumbs {...testi.breadcrumbs} />
      <Titolo>{testi.titolo}</Titolo>      
      <Chip
        color="success"
        label="Servizio Attivo"
        size="small"
        variant="outlined"
      />
      <Sottotitolo grigio>{testi.descrizione}</Sottotitolo>
      <BaseButtons.Custom testo="Paga online" color="success" size="large" sx={{px:'100px'}}/>
      <LineaSeparatrice />
      <MenuConScroll  sections={testi.sections}/>
    </FrontofficeContenitore>
  )
}

function MenuConScroll({sections}) {
  

  const [activeSection, setActiveSection] = useState('');


const [progress, setProgress] = useState(0);

 

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;

      const totalScrollable = docHeight - windowHeight;
      const percentScrolled = Math.min((scrollTop / totalScrollable) * 100, 100);

      setProgress(percentScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // inizializza la progress bar

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // NON VA CON WEB COMPONENT, USARE REF
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  /*
    useEffect(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    };

    observer.current = new IntersectionObserver((entries) => {
     /* entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });* /
      let closestElement = null;
      const visibleEntries = entries.filter(entry => entry.isIntersecting);

      if (visibleEntries.length > 0) {
        // Trova l'elemento con il top più vicino al margine superiore
        closestElement = visibleEntries.reduce((closest, entry) => {
          return (closest.boundingClientRect.top < entry.boundingClientRect.top) ? closest : entry;
        });

        setActiveSection(closestElement.target.id)
      }
    }, options);

    sections.forEach(section => {
      const element = document.getElementById(section.id);
      if (element) {
        observer.current.observe(element);
      }
    });

    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, []);

  */
    const elementsRef = useRef([]);
  useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      const visibleEntries = entries
        .filter(entry => entry.isIntersecting)
        .map(entry => ({
          id: Object.keys(elementsRef.current).find(
            key => elementsRef.current[key] === entry.target
          ),
          top: entry.boundingClientRect.top
        }))
        .sort((a, b) => a.top - b.top);

      if (visibleEntries.length > 0) {
        // Elemento più in alto visibile
        setActiveSection(visibleEntries[0].id);
      }
    },
    {
      root: null,
      rootMargin: '0px 0px -80% 0px', // Considera l’elemento visibile solo quando supera il 20% della viewport
      threshold: 0
    }
  );

  Object.keys(elementsRef.current).forEach(key => {
    if (elementsRef.current[key]) observer.observe(elementsRef.current[key]);
  });

  return () => {
    observer.disconnect();
  };
}, []);


function parseCustomButtons(markdown) {
  return markdown.replace(/\[!\[Button\s+"(.*?)"\s*(.*?)\]\]\[(.*?)\]/g, (match, label, rawProps, link) => {
    // Parsing dei parametri aggiuntivi
    const props = {};
    const regexProps = /(\w+)=([^\s]+)/g;
    let propMatch;

    while ((propMatch = regexProps.exec(rawProps)) !== null) {
      props[propMatch[1]] = propMatch[2];
    }

    // Costruisco la stringa props come attributi JSX
    const propsString = Object.entries(props)
      .map(([key, value]) => `${key}="${value}"`)
      .join(' ');

    return `<ButtonLink label="${label}" href="${link}" ${propsString} />`;
  });
}

  return (
    <>
      <Grid container spacing={2} sx={{mt:8}}>
        <Grid item xs={12} md={3} sx={{borderRight: '1px solid #ccc', paddingTop: '0!important'}}>
          <Box
            position="sticky"
            top={10} // Altezza dell'header per evitare sovrapposizioni
            p={0}
          > 
            <LinearProgress
              variant="determinate"
              value={progress}
              sx={{top: 0, left: 0, width: '100%', zIndex: 1200 }}
            />
            <List>
              {sections.map(section => (
              <ListItem  key={section.id}>
                <Link 
                  underline="hover"
                  onClick={() => scrollToSection(section.id)}
                  variant={activeSection === section.id ? 'contained' : 'outlined'}
                  color={activeSection === section.id ? 'primary' : 'inherit'}
                  sx={{
                    fontWeight:'600',
                    fontSize:'1rem',
                    lineHeight:'1rem',
                    paddingLeft: '20px',
                    ...(activeSection == section.id && { borderLeft: '2px solid #007a52' })
                  }}
                >
                  {section.label}</Link>
              </ListItem>
            ))}
            </List>
          </Box>
        </Grid>
        <Grid item md={1} />
        <Grid item xs={12} md={8} >
          
           {/* Contenuto */}
            {sections.map(section => (
              <Box
                ref={el => elementsRef.current[section.id] = el}
                key={section.id}
                id={section.id}
                mb={5}
                {...(section?.in_evidenza ? { my: 4, p: 3, bgcolor: "#f5f5f5", borderRadius: 2 }: null)}
                {...section?.rest}

              >
                <Titoletto>{section.label}</Titoletto>
                {(() => {
                    switch (section?.type) {
                      case 'contatti':
                        return  <Card raised><CardContent sx={{borderLeft: '#0000001f solid 11px'}}>
                                  <Typography variant="body2" color={'primary'} sx={{fontWeight:'bold',}} gutterBottom>
                                    {section?.contatti.titolo}
                                  </Typography>
                                  <Typography variant="body2">
                                    {section?.contatti.indirizzo}<br />
                                    {section?.contatti.telefono}<br />
                                    {section?.contatti.mail}<br />
                                  </Typography>
                                </CardContent></Card>
                      default:
                        return <Typography sx={{fontFamily: 'Lora,Georgia,serif', fontSize:'18px', lineHeight:'24px'}}>
                                <Markdown
                                options={{
                                  overrides: {
                                    ButtonLink: {
                                      component: ButtonLink,
                                    },
                                    a: {
                                      component: Link,
                                      props: {
                                        underline: 'hover',
                                        color:'success.main'
                                      },
                                    },
                                  },}}
                                >{parseCustomButtons(section.content)}</Markdown>
                              </Typography>
                    }
                  })()}

                
              </Box>
            ))}
     
        </Grid>
      </Grid>


      
    </>
  );
}

const ButtonLink = ({ label, href, color = 'primary', variant = 'contained', size = 'medium' }) => {
  const isExternal = href.startsWith('http');

  return (
    <Button
      variant={variant}
      color={color}
      size={size}
      component={isExternal ? 'a' : RouterLink}
      href={isExternal ? href : undefined}
      to={!isExternal ? href : undefined}
      sx={{ my: 1 }}
    >
      {label}
    </Button>
  );
};